import React from 'react';

let ctx;

// change these settings
let patternSize = 64,
   patternRefreshInterval = 1,
   patternAlpha = 28; // int between 0 and 255,

let patternPixelDataLength = patternSize * patternSize * 4,
   patternCanvas,
   patternCtx,
   patternData,
   frame = 0;

class Grain extends React.Component {
  
   // REF1: Crea empty ref
   refCanvas = React.createRef();

   componentDidMount() {
      this.initCanvas();
      this.initGrain();
      requestAnimationFrame(this.loop);
   }

   // create a canvas which will render the grain
   initCanvas = () => {
      ctx = this.refCanvas.current.getContext('2d');

      ctx.canvas.height = this.props.height;
      ctx.canvas.width = this.props.width;
   }

   // create a canvas which will be used as a pattern
   initGrain = () => {
      patternCanvas = document.createElement('canvas');
      patternCanvas.width = patternSize;
      patternCanvas.height = patternSize;
      patternCtx = patternCanvas.getContext('2d');
      patternData = patternCtx.createImageData(patternSize, patternSize);
   }

   // put a random shade of gray into every pixel of the pattern
   update = () => {
      let value;

      for (let i = 0; i < patternPixelDataLength; i += 4) {
         value = (Math.random() * 255) | 0;

         patternData.data[i] = value;
         patternData.data[i + 1] = value;
         patternData.data[i + 2] = value;
         patternData.data[i + 3] = patternAlpha;
      }

      patternCtx.putImageData(patternData, 0, 0);
   }

   // fill the canvas using the pattern
   draw = () => {
      ctx.clearRect(0, 0, this.props.width, this.props.height);
      ctx.fillStyle = ctx.createPattern(patternCanvas, 'repeat');
      ctx.fillRect(0, 0, this.props.width, this.props.height);
   }

   loop = () => {
      if (++frame % patternRefreshInterval === 0) {
         this.update();
         this.draw();
      }
      requestAnimationFrame(this.loop);
   }

   componentWillReceiveProps() {
      const delay = 400;

      setTimeout(() => {
         ctx.canvas.height = this.props.height;
         ctx.canvas.width = this.props.width;
       }, delay);
   }

   render() {
      const canvasStyle = {
         position: 'absolute',
         top: 0,
         left: 0,
         zIndex: 999,
         width: '100%',
         height: '100%',
         pointerEvents: 'none'
      }

      return (
        <canvas ref={this.refCanvas} style={canvasStyle} id="canvas"></canvas>
      );
   }
}

export default Grain;



// WEBPACK FOOTER //
// ./src/components/Grain.js